/**
 * Einzige Quelle für Quiz-Themen (Issue #17).
 * Die Werte entsprechen questions.topic in der D1-Datenbank.
 */
export const TOPICS = [
  { value: 'tauchphysik',  label: 'Tauchphysik' },
  { value: 'fwdv8',        label: 'FwDV 8' },
  { value: 'geraetekunde', label: 'Gerätekunde' },
  { value: 'physiologie',  label: 'Physiologie' },
  { value: 'tauchmedizin', label: 'Tauchmedizin' },
  { value: 'einsatzlehre', label: 'Einsatzlehre' },
  { value: 'recht',        label: 'Recht' },
];

/** Wert → Label, z.B. TOPIC_LABEL.fwdv8 === 'FwDV 8' */
export const TOPIC_LABEL = Object.fromEntries(TOPICS.map((t) => [t.value, t.label]));

/** Optionen für Filter-Selects (inkl. „Alle Themen") */
export const TOPIC_FILTER_OPTIONS = [{ value: '', label: 'Alle Themen' }, ...TOPICS];

/** Label mit Fallback auf den Rohwert (für unbekannte Themen aus der DB) */
export const topicLabel = (value) => TOPIC_LABEL[value] ?? value;
